/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Failed_Import_SettingsInputs */



/**
* | output |
* | --- |
* | "Failed to import settings" |
*
* @param {Failed_Import_SettingsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const failed_import_settings = /** @type {((inputs?: Failed_Import_SettingsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Failed_Import_SettingsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Échec de l'importation des paramètres")
	if (locale === "de") return /** @type {LocalizedString} */ ("Einstellungen konnten nicht importiert werden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile importare le impostazioni")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Не удалось импортировать настройки.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Error al importar la configuración")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("设置导入失败")
	if (locale === "ja") return /** @type {LocalizedString} */ ("設定のインポートに失敗しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सेटिंग्स आयात करने में विफल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Falha ao importar as configurações")
	return /** @type {LocalizedString} */ ("Failed to import settings")
});